import axios from 'axios';
import { BASEURL } from './constants';
import { useParams, useLocation } from "react-router-dom";

class NetworkError extends Error
{
  constructor(code, message)
  {
    const fullMessage = message ? `${ code }: ${ message }` : code;
    super(fullMessage);
    this.name = code;
    this.code = code;
    this.message = fullMessage;
  }

  toString()
  {
    return this.message;
  }
}

export const noneAuthInstance = axios.create({
  // Bypass CORS
  baseURL: BASEURL,
  timeout: 30000,
});

export const authInstance = axios.create({
  // Bypass CORS
  baseURL: BASEURL,
  timeout: 30000,
});

export const noneAuthPost = async (url, params) =>
{
  try
  {
    return await noneAuthInstance.post(url, params);
  } catch (error)
  {
    console.log('---noneAuthPost---error---', error)
    throw new NetworkError(error.response?.status, error.response?.data?.message ?? error.message);
  }
};

export const authPost = async (url, params) =>
{
//   const { token } = useParams();
  const query = new URLSearchParams(window.location.search);
  const token = query.get('token') || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwaG9uZU51bWJlciI6IjQxNjExMTExMSIsImlkIjo0LCJpYXQiOjE3NDE1NzcxOTF9.TCdDX_-bh0UKG98SVv7WxfWHbaTX3CjxirWq_UGktK4';
  // const token = window.localStorage.getItem('token') || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwaG9uZU51bWJlciI6IjQxNjExMTExMSIsImlkIjo0LCJpYXQiOjE3NDE1NzcxOTF9.TCdDX_-bh0UKG98SVv7WxfWHbaTX3CjxirWq_UGktK4';
  console.log('-----query.get token:------', query.get('token'));
  authInstance.defaults.headers.common = {
    Authorization: `Bearer ${token}`
  };

  try
  {
    const response = await authInstance.post(url, params);
    return response;
  } catch (error)
  {
    if (error.response?.data?.code === 401)
    {
    //   GlobalSerivce.logout();
    }

    throw new NetworkError(error.response?.status, error.response?.data?.message ?? error.message);
  }
};

export const authGet = async (url, params) =>
{
	const query = new URLSearchParams(window.location.search);
	const token = query.get('token') || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwaG9uZU51bWJlciI6IjQxNjExMTExMSIsImlkIjo0LCJpYXQiOjE3NDE1NzcxOTF9.TCdDX_-bh0UKG98SVv7WxfWHbaTX3CjxirWq_UGktK4';
	// const token = window.localStorage.getItem('token') || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwaG9uZU51bWJlciI6IjQxNjExMTExMSIsImlkIjo0LCJpYXQiOjE3NDE1NzcxOTF9.TCdDX_-bh0UKG98SVv7WxfWHbaTX3CjxirWq_UGktK4';
	console.log('-----query.get token:------', query.get('token'));
	authInstance.defaults.headers.common = {
	  Authorization: `Bearer ${token}`
	};

  try
  {
    const response = await authInstance.get(url, { params: params });

    return response;
  } catch (error)
  {
    if (error.response?.data?.code === 401)
    {
    //   GlobalSerivce.logout();
    }
    throw new NetworkError(error.response?.status, error.response?.data?.message ?? error.message);
  }
};

export const authDelete = async (url, params) =>
{
	const query = new URLSearchParams(window.location.search);
	const token = query.get('token') || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwaG9uZU51bWJlciI6IjQxNjExMTExMSIsImlkIjo0LCJpYXQiOjE3NDE1NzcxOTF9.TCdDX_-bh0UKG98SVv7WxfWHbaTX3CjxirWq_UGktK4';
	// const token = window.localStorage.getItem('token') || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwaG9uZU51bWJlciI6IjQxNjExMTExMSIsImlkIjo0LCJpYXQiOjE3NDE1NzcxOTF9.TCdDX_-bh0UKG98SVv7WxfWHbaTX3CjxirWq_UGktK4';
	console.log('-----query.get token:------', query.get('token'));
	authInstance.defaults.headers.common = {
	  Authorization: `Bearer ${token}`
	};

	try
	{
		const response = await authInstance.delete(url, { params: params });

		return response;
	} catch (error)
	{
		if (error.response?.data?.code === 401)
		{
		//   GlobalSerivce.logout();
		}
		throw new NetworkError(error.response?.status, error.response?.data?.message ?? error.message);
	}
};

export const authUpdate = async (url, params) =>
{
	const query = new URLSearchParams(window.location.search);
	const token = query.get('token') || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwaG9uZU51bWJlciI6IjQxNjExMTExMSIsImlkIjo0LCJpYXQiOjE3NDE1NzcxOTF9.TCdDX_-bh0UKG98SVv7WxfWHbaTX3CjxirWq_UGktK4';
	// const token = window.localStorage.getItem('token') || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwaG9uZU51bWJlciI6IjQxNjExMTExMSIsImlkIjo0LCJpYXQiOjE3NDE1NzcxOTF9.TCdDX_-bh0UKG98SVv7WxfWHbaTX3CjxirWq_UGktK4';
	console.log('-----query.get token:------', query.get('token'));
	authInstance.defaults.headers.common = {
	  Authorization: `Bearer ${token}`
	};

	try
	{
		const response = await authInstance.put(url, params);

		return response;
	} catch (error)
	{
		if (error.response?.data?.code === 401)
		{
		//   GlobalSerivce.logout();
		}
		throw new NetworkError(error.response?.status, error.response?.data?.message ?? error.message);
	}
};
